export default __webpack_public_path__ + "static/media/Group 2181.d08867f4.svg";